export default "__VITE_ASSET__CjG2ECI$__"